export const COMMUNITY_SPAM_SCORING_QUEUE = 'community-spam-scoring';

export type CommunitySpamScoringJob = {
  postId: string;
  communityId: string;
  authorId: string;
};
